import {
  REPLACE_USER_SUBSCRIPTION,
  REPLACE_USER_SUBSCRIPTION_STATUS,
} from '../actions'

import { initialState } from './consts'
import { replaceUserSubscription } from './utils'

export const handleReplaceUserSubscription = (
  state = initialState,
  action = {},
) => {
  switch (action.type) {
    case REPLACE_USER_SUBSCRIPTION.action:
      return {
        ...state,
        userActions: {
          id: action.payload.id,
          value: REPLACE_USER_SUBSCRIPTION_STATUS,
        },
      }
    case REPLACE_USER_SUBSCRIPTION.success:
      return {
        ...state,
        userActions: { action: null },
        adminData: {
          ...state.adminData,
          data: {
            ...state.adminData.data,
            ...action.payload,
            accounts: replaceUserSubscription(
              state.adminData.data.accounts,
              action.payload.accounts,
            ),
          },
        },
      }
    case REPLACE_USER_SUBSCRIPTION.failed:
      return {
        ...state,
        userActions: {
          value: null,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
